import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import dayjs from 'dayjs'

export const useOrderStore = defineStore('order', () => {
  // State
  const now = ref(dayjs())
  const deliveryLimit = ref(dayjs().hour(15).minute(0).second(0).millisecond(0))

  // Computed
  const deliveryLimitTimeLabel = computed(() => {
    // リミットを過ぎた場合は翌日のリミットに対して計算
    const limit = now.value.isBefore(deliveryLimit.value) ? deliveryLimit.value : deliveryLimit.value.add(1, 'day')
    const diffHours = limit.diff(now.value, 'hours')
    const diffMinutes = limit.diff(now.value.add(diffHours, 'hour'), 'minute')
    return `${diffHours}時間${String(diffMinutes).padStart(2, '0')}分以内`
  })
  const deliveryLimitDateLabel = computed(() => {
    // リミット前の場合は「当日発送」
    if(now.value.isBefore(deliveryLimit.value)) return '当日発送'
    const midnight = dayjs().hour(24).minute(0).second(0).millisecond(0)
    // 24時を超えた場合は「当日発送」/超えていない場合は「翌日発送」
    return now.value.isBefore(midnight) ? '翌日発送' : '当日発送'
  })

  // タイマー処理
  if (process.client) {
    // Reference: https://docs.google.com/spreadsheets/d/1Hh1M49TT8sJRGC0i6X5rvPWk296CGsKNhIbtDx4p7Hk/edit#gid=812391942&range=L12
    setInterval(() => {
      now.value = dayjs()
      deliveryLimit.value = dayjs().hour(15).minute(0).second(0).millisecond(0)
    }, 1000 * 60)
  }

  return {
    deliveryLimitTimeLabel,
    deliveryLimitDateLabel,
  }
})

export type OrderStore = ReturnType<typeof useOrderStore>
